import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { FuelConsumptionUnitEnum } from '../../shared/enums/fuel-consumption-unit.enum';
import { TagDto } from '../../tags/dtos/tag.dto';
import { VehicleAllocationEnum } from '../enums/vehicle-allocation.enum';
import { VehicleBodyTypeEnum } from '../enums/vehicle-body-type.enum';
import { VehicleDriveTrainTypeEnum } from '../enums/vehicle-drive-train-type.enum';
import { VehicleElectricBatteryTypeEnum } from '../enums/vehicle-electric-battery-type.enum';
import { VehicleEmissionsUnitCO2Enum } from '../enums/vehicle-emissions-unit-co2.enum';
import { VehicleEngineSizeUnitEnum } from '../enums/vehicle-engine-size-unit.enum';
import { VehicleFuelTankCapacityUnitEnum } from '../enums/vehicle-fuel-tank-capacity-unit.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehicleOdometerUnitEnum } from '../enums/vehicle-odometer-unit.enum';
import { VehiclePowerPlantTypeEnum } from '../enums/vehicle-power-plant-type.enum';
import { VehicleSteeringPositionEnum } from '../enums/vehicle-steering-position.enum';
import { VehicleTransmissionTypeEnum } from '../enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

/**
 * Create vehicle DTO
 */
export class CreateVehicleDto {
  color?: string | null;
  vin!: string;
  engineNumber?: string | null;
  notes?: string | null;
  type!: VehicleTypeEnum;
  licensePlate?: string | null;
  @TransformDate()
  registeredAt?: Date | null;
  @TransformDate()
  deregisteredAt?: Date | null;
  @TransformInt()
  makeId?: number | null;
  @TransformInt()
  modelId?: number | null;
  @TransformInt()
  year?: number | null;
  @TransformInt()
  seats?: number | null;
  series?: string | null;
  trim?: string | null;
  @TransformDate()
  manufacturedAt?: Date | null;
  @TransformInt()
  exteriorColorId?: number | null;
  @TransformInt()
  interiorColorId?: number | null;
  bodyType!: VehicleBodyTypeEnum;
  fuelType?: VehicleFuelTypeEnum | null;
  steeringPosition?: VehicleSteeringPositionEnum | null;
  @TransformInt()
  doors?: number | null;
  transmissionType?: VehicleTransmissionTypeEnum | null;
  driveTrainType?: VehicleDriveTrainTypeEnum | null;
  odometerUnit?: VehicleOdometerUnitEnum | null;
  primaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  secondaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  engineSizeUnit?: VehicleEngineSizeUnitEnum | null;
  @TransformInt()
  engineSize?: number | null;
  @TransformInt()
  engineOutput?: number | null;
  engineTurbine?: boolean | null;
  @TransformInt()
  averageEmissionsCO2?: number | null;
  emissionsUnitCO2?: VehicleEmissionsUnitCO2Enum | null;
  @TransformInt()
  averageFuelConsumption?: number | null;
  fuelConsumptionUnit?: FuelConsumptionUnitEnum | null;
  @TransformInt()
  fuelTankCapacity?: number | null;
  fuelTankCapacityUnit?: VehicleFuelTankCapacityUnitEnum | null;
  @TransformInt()
  averageElectricConsumption?: number | null;
  @TransformInt()
  electricBatteryCapacity?: number | null;
  @TransformInt()
  electricBatteryVoltage?: number | null;
  electricBatteryType?: VehicleElectricBatteryTypeEnum | null;
  @TransformInt()
  electricMotorOutput?: number | null;
  @TransformInt()
  electricMotorRangeFrom?: number | null;
  @TransformInt()
  electricMotorRangeTo?: number | null;
  allocation!: VehicleAllocationEnum;
  @TransformInt()
  supplierId?: number | null;
  @TransformInt()
  locationId?: number | null;
  @TransformInt()
  vehicleCategoryId?: number | null;
  @TransformDate()
  purchasedAt?: Date | null;
  @TransformFloat()
  purchaseListPrice?: number | null;
  @TransformFloat()
  purchasePaidPrice?: number | null;
  @TransformInt()
  featureItems?: number[] | null;
  tags?: TagDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
  hasGpsTracker?: boolean | null;
  gpsTrackerUuid?: string | null;
}
